import type { FindUrlParamsQuery } from "schemas/generated/analyticsRead";

import * as React from "react";

import { skipToken } from "@tanstack/react-query";
import { analyticsRouter } from "@v2/trpc/routes/analytics";

import { useAnalyticsQueryContext } from "./contexts/AnalyticsQueryContext";

const useFindUrlParams = (query: FindUrlParamsQuery) => {
  const { workspaceId, projectId } = useAnalyticsQueryContext();

  const shouldFetch = (workspaceId || projectId) && query.urlHosts.length > 0;

  const {
    data,
    isLoading,
    refetch: refetchUrlParams,
  } = analyticsRouter.findUrlParams.useQuery(
    shouldFetch ? { query, workspaceId, projectId } : skipToken,
  );

  const [urlParams, setUrlParams] = React.useState(data?.urlParams);

  // biome-ignore lint/correctness/useExhaustiveDependencies: We want this for now
  React.useEffect(() => {
    const fetchData = async () => {
      const response = await refetchUrlParams();
      setUrlParams(response.data?.urlParams);
    };

    if (shouldFetch) {
      void fetchData();
    }
  }, [query, workspaceId, refetchUrlParams, shouldFetch, setUrlParams]);
  return {
    urlParams: urlParams ?? null,
    isLoading,
  };
};

export default useFindUrlParams;
